import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private scope: string,
    private commonPrefix: string = './assets/i18n/common/',
    private scopePrefix: string = './assets/i18n/',
    private suffix: string = '.json'
  ) {}

  public getTranslation(lang: string): Observable<any> {
    const common$ = this.http.get(`${this.commonPrefix}${lang}${this.suffix}`).pipe(
      catchError(() => of({})) // Em caso de erro, retorna um objeto vazio
    );

    const scope$ = this.http.get(`${this.scopePrefix}${this.scope}/${lang}${this.suffix}`).pipe(
      catchError(() => of({})) // Em caso de erro, retorna um objeto vazio
    );

    return forkJoin([common$, scope$]).pipe(
      map(([common, scope]) => {
        return { ...common, ...scope };
      })
    );
  }
}
